import { message } from 'ant-design-vue'
import request, { IPage, IWorkspaceResponse, IListWorkspaceResponse } from '/@/api/http/request'

// 创建航线文件夹
export const createWaylineFolder = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline/api/v1/wayline-folder/save'
  const result = await request.post(url, body)
  return result.data
}

// 获取航线文件夹列表
export const getWaylineFolderList = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline/api/v1/wayline-folder/list'
  const result = await request.post(url, body)
  return result.data
}

// 获取未绑定文件夹的航线文件列表
export const getUnboundWaylineFolderList = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline/api/v1/wayline-file/list'
  const result = await request.post(url, body)
  return result.data
}

// 获取绑定文件夹的航线文件列表
export const getBoundWaylineFolderList = async function (folderId): Promise<IWorkspaceResponse<any>> {
  const url = `/wayline/api/v1/wayline-file/list-by-folder-id/${folderId}`
  const result = await request.post(url, folderId)
  return result.data
}

// 更新航线文件到文件夹
export const getUpdateWaylineFolder = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline/api/v1/wayline-file-to-folder/update'
  const result = await request.post(url, body)
  return result.data
}

// 删除航线文件夹
export const deleteWaylineFolder = async function (id: string): Promise<IWorkspaceResponse<any>> {
  const url = `/wayline/api/v1/wayline-folder/delete/${id}`
  const result = await request.delete(url)
  return result.data
}

// 获取航线文件夹树
export const getWaylineFolderTree = async function (): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline/api/v1/wayline-folder/tree'
  const result = await request.get(url)
  return result.data
}
